import React, { PropsWithChildren } from 'react';

export const HelpMessage = ({ children }: PropsWithChildren) => (
  <>
    {typeof children !== 'string' && children}
    {typeof children === 'string' && <small>{children}</small>}
  </>
);
